import { Injectable } from '@angular/core';
import { MenuManagementService } from '../../services/common/menu-managemen';


import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../services/shared/toastservice';
import { debug } from 'util';
import { JwtService } from '../../services/authentication/guards/jwt.service';
import { AppSelectService } from '../../services/shared/appSelectService';
import { Router } from '@angular/router';



export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

// const MENUITEMS = [
//   {
//     label: 'Other',
//     main: [
//       {
//         state: 'dashboard',
//         short_label: 'D',
//         name: 'Dashboard',
//         type: 'sub',
//         icon: 'fa fa-dashboard',
//         children: [
//           {
//             state: 'dashboard-default',
//             name: 'Default'
//           }
//         ]
//       },
//       {
//         state: 'company',
//         name: 'Company Management',
//         type: 'link',
//         icon: 'fa fa-building'
//       },
//       {
//         state: 'app',
//         name: 'App Management',
//         type: 'link',
//         icon: 'fa fa-apple'
//       },
//       {
//         state: 'unit',
//         name: 'Unit Management',
//         type: 'link',
//         icon: 'fa fa-university'
//       },
//       {
//         state: 'category',
//         name: 'Category Management',
//         type: 'link',
//         icon: 'fa fa-sticky-note-o'
//       },
//       {
//         state: 'user',
//         name: 'User Management',
//         type: 'link',
//         icon: 'fa fa-users'
//       },
//       {
//         state: 'news',
//         name: 'News Management',
//         type: 'link',
//         icon: 'fa fa-newspaper-o'
//       },
//       {
//         state: 'event',
//         name: 'Event Management',
//         type: 'link',
//         icon: 'fa fa-calendar'
//       },
//       {
//         state: 'faq',
//         name: 'FAQ Management',
//         type: 'link',
//         icon: 'fa fa-question'
//       },
//       {
//         state: 'offer',
//         name: 'Offer Management',
//         type: 'link',
//         icon: 'fa fa-money'
//       },
//       {
//         state: 'link',
//         name: 'Link Management',
//         type: 'link',
//         icon: 'fa fa-link'
//       },
//       {
//         state: 'forms',
//         name: 'Forms Management',
//         type: 'link',
//         icon: 'fa fa-dot-circle-o'
//       },
//       {
//         state: 'checklist',
//         name: 'Checklist Management',
//         type: 'link',
//         icon: 'fa fa-check-square-o'
//       },
//       {
//         state: 'contact',
//         name: 'Contact Management',
//         type: 'link',
//         icon: 'fa fa-phone'
//       },
//       {
//         state: 'notification',
//         name: 'Notification Management',
//         type: 'link',
//         icon: 'fa fa-mobile'
//       }
//     ],
//   }
// ];


@Injectable()
export class MenuItems {
  listOfModules: any;
  constructor(private toastService: ToastService, private jwtService: JwtService, private menuManagementService: MenuManagementService, private router: Router, private appSelectService: AppSelectService) {
    // translate.addLangs(['en', 'se']);
    // // this language will be used as a fallback when a translation isn't found in the current language
    // translate.setDefaultLang('en');

    // // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use('en');



    this.appSelectService.changeEmitted$.subscribe(

      (selectedAppId) => {
        this.menuManagementService.getMenu(selectedAppId).subscribe(
          data => {
            this.listOfModules = data.json().data;            
          },
          error => {
            if (error.status == 401 || error.status == 403) {

              this.jwtService.destroyToken();
              return this.router.navigateByUrl('/authentication/login');
            }
            var obj = { title: '', msg: '', type: '' };
            obj.title = 'Menu';
            obj.msg = 'Error while getting menu list.';
            obj.type = 'error';
            this.toastService.notify(obj);

          });
      });    
    var selectedApp = this.jwtService.getApp();
    this.menuManagementService.getMenu(selectedApp.Id).subscribe(
      data => {
        this.listOfModules = data.json().data;
      },
      error => {
        if (error.status == 401 || error.status == 403) {

          this.jwtService.destroyToken();
          return this.router.navigateByUrl('/authentication/login');
        }
        var obj = { title: '', msg: '', type: '' };
        obj.title = 'Menu';
        obj.msg = 'Error while getting menu list.';
        obj.type = 'error';
        this.toastService.notify(obj);

      });


  }

  getAll(): Menu[] {
    return this.listOfModules;
  }

  getAllVal(): Menu[] {
    this.listOfModules = [];
    return this.listOfModules;
  }

  // // add(menu: Menu) {
  // //   MENUITEMS.push(menu);
  // // }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/shared/menu-items/menu-items.ts